<template>
  <div>
    <Head :title="$t('applicants.applicants')" />
    <h1 class="mb-8 text-3xl font-bold">{{ $t('applicants.applicants') }}</h1>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="applicants"
      cookie-name="applicants"
      :remember-table="true"
    >
      <template #extraButtons>
        <Link class="btn-indigo inline-flex items-center mr-2" href="/applicants/create" style="height: 38px">
          <icon name="plus" class="w-4 h-4 fill-current text-white mr-2" />
          <span class="capitalize">{{ $t('applicants.new') }}</span>
        </Link>
      </template>
      <template #cell(date_birth)="{ item: data }">
        {{ $filters.formatDate(data.date_birth) }}
      </template>
      <template #cell(latest_intervention)="{ item: data }">
        {{ $filters.formatDate(data.latest_intervention) }}
      </template>
      <template #cell(name)="{ item: data }">
        <span v-if="data.closed" class="font-bold text-red-500">{{data.name}}</span>
        <span v-else>{{data.name}}</span>
      </template>
      <template #cell(types)="{ item: applicant }">
        <badge v-for="(type, key) in applicant.types" :key="key" :text="$t('treatment-types.'+type)" />
      </template>
      <template #cell(languages)="{ item: applicant }">
        {{ applicant.languages.join(', ') }}
      </template>
    </Table>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'
import Badge from '@/Shared/Badge'
export default {
  components: {
    Head,
    Icon,
    Link,
    Table,
    Badge,
  },
  layout: Layout,
  props: {
    data: Object,
  },
}
</script>
